import { noValidation } from '@post-office/placement-common-v2';
import {
	PlacementBackend,
	PlacementFrontend,
} from '@post-office/placements--growth/confluence-side-nav';
import { TwcSampleBanner } from '@atlassian/twc-sample-banner';

import { useHandleDismiss } from '../../../hooks/use-handle-dismiss';
import { type MessageTemplateContext } from '../../..';
import { assertMessageTemplateContext } from '../../../__generated__/validation/messageTemplateContext';

type MessageFrontendProps = MessageTemplateContext & {
	handleOnDismissed: () => void;
	onboardingUrl: string;
};

// Custom backend that fetches TCS hostname and TAP site trait to build the Confluence onboarding URL
export const MessageBackend = PlacementBackend.createMessageBackend(() => ({
	transformMetadata: {
		validate: noValidation(),
		stage: () => ({
			goalMetadata: {
				primaryGoal: {
					goalId: 'clickthrough',
				},
			},
		}),
	},
	hydrate: {
		validate: assertMessageTemplateContext,
		stage: async ({ message, request }) => {
			const { logger, orchestrationContext, query, headers, additionalContext, body } = request;
			const { messageInstanceId, messageTemplateId } = message;
			logger.info(
				{ messageInstanceId, messageTemplateId, message },
				'Hydrating twc-sidenav-confluence-banner (in-app-v2/confluence-side-nav): message',
			);
			logger.info(
				{ messageInstanceId, messageTemplateId, orchestrationContext },
				'Hydrating twc-sidenav-confluence-banner (in-app-v2/confluence-side-nav): orchestrationContext',
			);
			logger.info(
				{ messageInstanceId, messageTemplateId, query },
				'Hydrating twc-sidenav-confluence-banner (in-app-v2/confluence-side-nav): query',
			);
			logger.info(
				{ messageInstanceId, messageTemplateId, headers },
				'Hydrating twc-sidenav-confluence-banner (in-app-v2/confluence-side-nav): headers',
			);
			logger.info(
				{ messageInstanceId, messageTemplateId, additionalContext },
				'Hydrating twc-sidenav-confluence-banner (in-app-v2/confluence-side-nav): additionalContext',
			);
			logger.info(
				{ messageInstanceId, messageTemplateId, body },
				'Hydrating twc-sidenav-confluence-banner (in-app-v2/confluence-side-nav): body',
			);
			const onboardingUrl = 'https://atlassian.com';

			return {
				...message.context,
				onboardingUrl: onboardingUrl,
			};
		},
	},
}));

export const MessageFrontend = PlacementFrontend.createMessageFrontend({
	render: {
		validate: assertMessageTemplateContext,
		Component: ({ handleOnDismissed, onboardingUrl }: MessageFrontendProps) => {
			const { handleDismiss } = useHandleDismiss({ onDismissed: handleOnDismissed });

			return (
				<TwcSampleBanner
					product="confluence"
					onClose={handleDismiss}
					href={onboardingUrl}
					margin="space.150"
				/>
			);
		},
	},
});
